import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[pioneerLowercase]'
})
export class LowercaseDirective {

  constructor(
    private control: NgControl
  ) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.convertCase(value);
  }

  private convertCase(value: string) {
    this.control.control.patchValue(value.toLowerCase());
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/directives/lowercase.directive.ts